import React, { useMemo, useRef, useCallback, useState, useContext } from "react";
import {
  GoogleMap,
  Marker,
  InfoWindow,
  useJsApiLoader,
} from "@react-google-maps/api";
// import { google_api } from "../../../../../config";
import icon from "../../../../../assets/images/Logo-farmageo-borde.png";
import MapaInfo from "../../../ListadoV2/components/MapaInfo";
import { ThemeContext } from "../../../../../Theme";

export function Mapa(props) {
  const { data, cab } = props;
  const theme = useContext(ThemeContext)
  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: theme.api_key_maps,
  });

  // Obtener latitud y longitud desde data o desde las propiedades del objeto cab
  const lat = parseFloat(data[cab.id_a + "_mapa_latitud"] ?? cab.mapa_latitud);
  const lng = parseFloat(
    data[cab.id_a + "_mapa_longitud"] ?? cab.mapa_longitud
  );
  const zoom = cab.mapa_zoom ? Number(cab.mapa_zoom) : lat && lng ? 15 : 3;

  const center = {
    lat: lat ?? -38.416097,
    lng: lng ?? -63.616672,
  };

  // Estado para InfoWindow (opcional, si necesitas mostrar contenido adicional)
  const [, forceUpdate] = useState(false);

  const showInfoWindowRef = useRef(false);
  const selectedElementRef = useRef(null);
  const activeMarkerPosRef = useRef(null);
  const hoverTimeoutRef = useRef(null);

  const mapaInfoConfig = cab.sc_hijos?.filter(
    (f) => f.componente === "mapa_info"
  );
  const hayMapaInfo = mapaInfoConfig?.length > 0;

  const handleMouseOut = useCallback(() => {
    if (!hayMapaInfo) return;
    hoverTimeoutRef.current = setTimeout(() => {
      selectedElementRef.current = null;
      activeMarkerPosRef.current = null;
      showInfoWindowRef.current = false;
      forceUpdate((f) => !f);
    }, 300);
  }, [hayMapaInfo]);

  // Función para manejar el clic en el marcador
  const handleMarkerClick = () => {
    window.open(
      `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`
    );
  };

  // Opciones de contenedor del mapa
  const containerStyle = {
    width: cab.width || "95%",
    height: cab.height || "200px",
  };
  const googleMapStyle = {
    width: "100%",
    height: cab.height || "200px",
  };

  const markerIcon = useMemo(() => {
    if (!isLoaded || !window.google?.maps) return undefined;
    return {
      url: icon,
      scaledSize: new window.google.maps.Size(25, 25),
      anchor: new window.google.maps.Point(0, 25),
    };
  }, [isLoaded]);

  if (loadError) return <div>Error al cargar el mapa</div>;
  if (!isLoaded) return <></>;

  return (
    <div className="map_container" style={containerStyle}>
      <GoogleMap mapContainerStyle={googleMapStyle} zoom={zoom} center={center}>
        <Marker
          position={center}
          icon={markerIcon}
          onClick={handleMarkerClick}
          // options={{draggable:true}}
        />
        {showInfoWindowRef.current && activeMarkerPosRef.current && (
          <InfoWindow position={activeMarkerPosRef.current} onCloseClick={handleMouseOut}>
            {selectedElementRef.current && (
              <MapaInfo
                selectedElement={selectedElementRef.current}
                mapaInfo={mapaInfoConfig[0]}
                cab={cab}
                data={data}
              />
            )}
          </InfoWindow>
        )}
      </GoogleMap>
    </div>
  );
}

export default Mapa;
